import React from "react";

const Colors = ({ product, handleColorChange }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "4px", paddingTop: "12px" }}>
      {product.colors.map((color, index) => (
        <span
          key={index}
          onClick={() => handleColorChange(color.colorCode)}
          style={{
            border: `2px solid ${color.isColor ? color.colorCode : "transparent"}`,
            width: "20px",
            height: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            borderRadius: "4px",
            transition: "border 0.3s ease",
          }}
        >
          <span
            style={{
              backgroundColor: color.colorCode,
              width: "12px",
              height: "12px",
              display: "inline-block",
              borderRadius: "2px",
            }}
          ></span>
        </span>
      ))}
    </div>
  );
};

export default Colors;
